import React from 'react';
import { UploadedFile } from 'web-library/models/UploadedFile';

export const prepareFiles = (
  files: UploadedFile[],
  setFiles: React.Dispatch<React.SetStateAction<UploadedFile[]>>
) => {
  const newFiles = files.map((file) => {
    if (!file.uploaded) {
      // eslint-disable-next-line no-param-reassign
      file.pending = true;
    }
    return file;
  });
  setFiles(newFiles);
  return {
    filenames: newFiles.map((uploadFile) => uploadFile.file.name),
  };
};
